<template>
  <div
    class="app-main-inner tracking-form"
    style="display: flex;flex-direction: column"
  >
    <div class="app-main-inner-row" style="margin-left: -32px !important;">
      <div style="display: flex;flex-direction: row; width: 100%">
        <!--节点-基本信息-->
        <el-card class="box-card" style="height: 100%;width: 400px;">
          <div slot="header">
            <span>{{ title }}</span>
          </div>
          <el-form ref="trackingForm" :disabled="readOnly" style="width:100%;" label-position="left" label-width="90px">
            <el-form-item :label="$t('Pricing.FeeIndex')">
              <el-input-number
                v-model="trackingForm.level"
                controls-position="right"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_Code')">
              <el-input v-model="trackingForm.code" :disabled="isPlatformCode" @blur="() => trackingForm.code = trackingForm.code.trim()" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_ChineseNamed')">
              <el-input v-model="trackingForm.codeCname" :disabled="isPlatformCode" @blur="() => trackingForm.codeCname = trackingForm.codeCname.trim()" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_EnglishNamed')">
              <el-input v-model="trackingForm.codeEname" :disabled="isPlatformCode" @blur="() => trackingForm.codeEname = trackingForm.codeEname.trim()" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_NodeType')">
              <el-select v-model="trackingForm.nodeType" :clearable="false" class="input-w">
                <el-option v-for="(item,index) in $constantI18n('nodeType')" :key="index" :label="item.name" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-checkbox v-model="trackingForm.allowTriggerRollback">{{ $t('SystemMaintenance.AllowStatusToTriggerRollback') }}</el-checkbox>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_NodeType')">
              <el-checkbox v-model="trackingForm.published">{{ $t('CargoMsg.Cargo_WhetherToDisclose') }}</el-checkbox>
            </el-form-item>
            <template v-if="isNew || isEdit">
              <el-form-item :label="$t('CargoMsg.Cargo_ApplicationScope')">
                <el-radio-group v-model="trackingForm.applicationScope" @change="onApplicationScopeChange">
                  <el-radio :label="0" style="margin-top: 7px;">{{ isNew ? $t('SystemMaintenance.AddOnlyCurrentTemplate') : $t('SystemMaintenance.OnlyModifyCurrentTemplate') }}</el-radio>
                  <el-radio :label="1" style="margin: 5px 0 7px 0;">{{ isNew ? $t('SystemMaintenance.AddOtherSameLobTempalte') : $t('SystemMaintenance.ModifyTemplateContaneNode') }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item v-if="isNew && trackingForm.applicationScope === 1" :label="$t('SystemMaintenance.ApplicationTemplate')">
                <el-input disabled :value="applicationTemplateLabel" @dblclick.native="showTemplateSelectDialog" />
              </el-form-item>
            </template>
            <el-form-item v-if="isPlatform" :label="$t('CargoMsg.Cargo_QuicklyConfigureSettings')">
              <el-checkbox v-model="trackingForm.quickConfiguration">
                {{ $t('CargoMsg.Cargo_QuickConfigurationIsCheckedByDefault') }}</el-checkbox>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_Remarks')">
              <el-input
                v-model="trackingForm.remark"
                type="textarea"
                :rows="3"
              />
            </el-form-item>
          </el-form>
          <el-form v-if="trackingForm.uuid && !isPlatform" style="width:100%;" label-position="left" label-width="90px">
            <el-form-item label-width="0" class="auto-width">
              <div style="flex: 1; display: flex;">
                <span class="el-form-item__label">{{ $t('Menu.Icon') }}</span>
                <i class="el-icon-warning" style="color: #1f75d5; font-size: 16px; cursor: pointer; padding-right: 38px; padding-top: 5px;" :title="$t('CargoMsg.Cargo_TrackingIconTip')" />
                <div :style="currentCss + 'width: 68px; height: 68px; border: 1px solid #dddfe6; border-radius: 2px; text-align:center; cursor: pointer;'">
                  <cargo-el-upload
                    v-if="!trackingForm.documentId"
                    :action="URL.sys.uploadTrackingIcon"
                    :show-file-list="false"
                    :data="{trackingUuid:trackingForm.uuid}"
                    :before-upload="beforeUpload"
                    :on-progress="handleProgress"
                    :on-success="handleSuccess"
                    :on-error="handleError"
                    list-type="picture"
                    style="display: inline-block; padding-left: 5px; padding-right: 5px;"
                  >
                    <img :src="currentIcon" width="22" height="22" style="margin-top:23px;" alt="">
                  </cargo-el-upload>
                  <img v-if="trackingForm.documentId" :src="currentIcon" width="22" height="22" style="margin-top:23px;" @mouseover="mouseoverIcon()" @click="clickIcon()" @mouseleave="mouseleaveIcon()">
                </div>
              </div>
            </el-form-item>
            <el-form-item>
              <span style="color: #b1b4b4ff">{{ $t('CargoMsg.Cargo_TrackingTipTwo') }}</span>
            </el-form-item>
          </el-form>
          <el-form v-if="isNew || isEdit" label-width="0">
            <el-form-item>
              <div style="display: flex;line-height: 18px;">
                <i class="el-icon-warning" style="color: #E6A23C;font-size: 14px;margin-right: 5px;" />
                <span>{{ $t('SystemMaintenance.SetNodeLimitTip') }}</span>
              </div>
            </el-form-item>
          </el-form>
          <el-form :disabled="readOnly" label-width="0" style="margin-top: 15px">
            <span class="title">{{ $t('SystemMaintenance.ToDoNodeRuleSettings') }}</span>
            <el-form-item>
              <el-checkbox v-model="trackingForm.workTaskIgnoreMaster">{{ $t('SystemMaintenance.MainNotToDoTask') }}</el-checkbox>
              <el-checkbox v-model="trackingForm.sopBoardNotShow">{{ $t('CargoMsg.Cargo_SOPPanelNodeNotDisplayed') }}</el-checkbox>
            </el-form-item>
          </el-form>
          <!--          <el-form v-if="isSE" :disabled="readOnly" style="width:100%;" label-position="left" label-width="90px">-->
          <!--            <span class="title">{{ $t('SystemMaintenance.ServiceScenarioApplication') }}</span>-->
          <!--            <el-form-item :label="$t('SystemMaintenance.SettingApplicationScenarios')">-->
          <!--              <el-select v-model="trackingForm.genDocCondition" :clearable="true" class="input-w">-->
          <!--                <el-option v-for="(item,index) in $constantI18n('genDocCondition')" :key="index" :label="item.name" :value="item.value" />-->
          <!--              </el-select>-->
          <!--            </el-form-item>-->
          <!--          </el-form>-->
          <!--          <el-form v-if="isSE" :disabled="readOnly" style="width:100%;" label-position="left" label-width="90px">-->
          <!--            <span class="title">{{ $t('SystemMaintenance.OperationButtonSettings') }}</span>-->
          <!--            <el-form-item :label="$t('SystemMaintenance.ButtonName')">-->
          <!--              <el-select v-model="trackingForm.buttonName" :clearable="true" class="input-w">-->
          <!--                <el-option v-for="(item,index) in $constantI18n('buttonName')" :key="index" :label="item.name" :value="item.value" />-->
          <!--              </el-select>-->
          <!--            </el-form-item>-->
          <!--          </el-form>-->
        </el-card>
        <!--节点-工作任务信息-->
        <el-card v-if="trackingTemplateForm.workTaskEnable || isPlatform" class="box-card" style="width: 468px;">
          <el-form :disabled="readOnly" style="width:100%;" label-position="left" label-width="0px">
            <!--节点-工作任务信息-岗位-->
            <span class="title" :title="$t('CargoMsg.Cargo_SetNodeResponsible')">{{ $t('CargoMsg.Cargo_SetNodeResponsible') }}</span>
            <el-form-item>
              <el-checkbox v-model="positionEnable" @change="positionEnableChange()">{{ $t('CargoMsg.AssignedWorkResponsibleForNode') }}</el-checkbox>
            </el-form-item>
            <el-form-item>
              <cargo-advance-select
                :disabled="!positionEnable"
                multiple
                :default-multiple-value="designatedPositions"
                filterable
                :static-options="positionOptions"
                tag-name="chineseName"
                tag-value="code"
                :filter-tag-names="['code', 'chineseName', 'englishName']"
                style="width:370px;"
                options-width="230px"
                @parentCallBack="p=>{designatedPositions=p.value||[]}"
              />
            </el-form-item>
            <el-form-item v-show="!isPlatform" label="">
              <el-checkbox v-model="personnelEnable" @change="personnelEnableChange()">{{ $t('CargoMsg.Cargo_DesignatedPersonnel') }}</el-checkbox>
              <cargo-advance-select
                :select-type="selectTypeNames.basic_data_User"
                :fields="['chineseName']"
                :disabled="!personnelEnable"
                :callback-params="{key:'userId'}"
                callback-method-type="obj"
                tag-value="userId"
                tag-name="chineseName"
                :filter-tag-names="['chineseName']"
                :method-params="{pageSize: 1000000, active: true, hasRole: true}"
                multiple
                :default-multiple-value="designatedPersons"
                filterable
                style="width:370px;"
                options-width="230px"
                @parentCallBack="p=>{designatedPersons=p.value||[]}"
              />
            </el-form-item>
            <!--节点-工作任务信息-前置节点-->
            <span style="margin-top: 20px;" class="title" :title="$t('CargoMsg.Cargo_SetPreNode')">{{ $t('CargoMsg.Cargo_SetPreNode') }}</span>
            <el-form-item style="margin-left: 15px">
              <span>{{ $t('CargoMsg.Cargo_SetPreNodeTips') }}<i style="color: #42b983; cursor: pointer; position: absolute; right: 35px; top: 5px; font-size: 18px" class="el-icon-circle-plus" @click="addTrackingWtPreNode" /></span>
            </el-form-item>
            <el-form-item v-for="(trackingWtPreNode, index) in trackingForm.trackingWtPreNodes" :key="index" style="margin-left: 15px">
              <div style="display: flex; align-items: center; justify-content: flex-start">
                <el-select
                  v-model="trackingWtPreNode.preTrackingUuid"
                  style="width: 170px"
                  filterable
                  @change="preTrackingChange($event, trackingWtPreNode)"
                >
                  <el-option
                    v-for="(item,index) in preTrackingOptions"
                    :key="index"
                    :label="isZh ? item.chineseName : item.englishName"
                    :value="item.uuid"
                  />
                </el-select>
                <!--                <el-select-->
                <!--                  v-model="trackingWtPreNode.preTrackingDetailUuids"-->
                <!--                  style="margin-left: 10px; width: 170px"-->
                <!--                  filterable-->
                <!--                  multiple-->
                <!--                >-->
                <!--                  <el-option-->
                <!--                    v-for="(item,index) in trackingWtPreNode.trackingDetails"-->
                <!--                    :key="index"-->
                <!--                    :label="isZh ? item.chineseName : item.englishName"-->
                <!--                    :value="item.uuid"-->
                <!--                  />-->
                <!--                </el-select>-->
                <cargo-advance-select
                  style="margin-left: 10px; width: 170px"
                  filterable
                  clearable
                  multiple
                  tag-value="uuid"
                  :static-options="trackingWtPreNode.trackingDetails"
                  :default-multiple-value="trackingWtPreNode.preTrackingDetailUuids"
                  @parentCallBack="p=>{trackingWtPreNode.preTrackingDetailUuids=p.value}"
                />
                <i style="color: #f56c6c; cursor: pointer; position: absolute; right: 35px; top: 5px; font-size: 18px" class="el-icon-remove" @click="deleteTrackingWtPreNode(index)" />
              </div>
            </el-form-item>

            <!--节点-工作任务信息-优先级-->
            <span style="margin-top: 20px;" class="title" :title="$t('CargoMsg.Cargo_HandlingPriorityMarkers')">{{ $t('CargoMsg.Cargo_HandlingPriorityMarkers') }}</span>
            <div style="margin-left: 15px">
              <!--              <el-form-item>-->
              <!--                <span>{{ $t('CargoMsg.Cargo_HandlingPriorityMarkersTips') }}</span>-->
              <!--              </el-form-item>-->
              <!--节点-工作任务信息-优先级-高-->
              <el-form-item>
                <el-checkbox v-model="priorityHighEnable" @change="priorityHighEnableChange()">{{ $t('CargoMsg.Cargo_HandlingPriorityMarkersHigh') }}</el-checkbox>
              </el-form-item>
              <el-form-item>
                <span>{{ $t('CargoMsg.Cargo_ConditionalItem') + ': ' }}</span>
                <cargo-advance-select
                  :disabled="!priorityHighEnable"
                  :default-value="trackingForm.trackingWtPriority.conditionFieldHigh"
                  :static-options="priorityConditions"
                  tag-value="code"
                  filterable
                  filter-type="global"
                  :cache="false"
                  style="margin-left: 10px; width: 296px; display: inline-block"
                  @parentCallBack="p=>{trackingForm.trackingWtPriority.conditionFieldHigh=p.value}"
                />
                <div style="margin-top: 10px;">
                  <el-select v-model="trackingForm.trackingWtPriority.triggerMethodHigh" :disabled="!priorityHighEnable" style="width: 65px; margin-right: 5px">
                    <el-option :value="1" :label="$t('CargoMsg.Cargo_BringForward')" />
                    <el-option :value="2" :label="$t('CargoMsg.Cargo_Postpone')" />
                  </el-select>
                  <el-input-number v-model="trackingForm.trackingWtPriority.hourHigh" :disabled="!priorityHighEnable" type="number" oninput="value=value.replace(/[^\d]/g,'')" :step="1" :controls="false" style="width: 112px; margin-left: 5px; margin-right: 5px" />
                  <span>{{ $t('Pricing.Hour') }}</span>
                  <el-input-number v-model="trackingForm.trackingWtPriority.minuteHigh" :disabled="!priorityHighEnable" type="number" :min="0" :max="59" :step="1" :controls="false" style="width: 112px; margin-left: 5px; margin-right: 5px" />
                  <span>{{ $t('SeaExport.Minute') }}</span>
                </div>
              </el-form-item>
              <!--节点-工作任务信息-优先级-中-->
              <el-form-item>
                <el-checkbox v-model="priorityMediumEnable" @change="priorityMediumEnableChange()">{{ $t('CargoMsg.Cargo_HandlingPriorityMarkersMedium') }}</el-checkbox>
              </el-form-item>
              <el-form-item>
                <span>{{ $t('CargoMsg.Cargo_ConditionalItem') + ': ' }}</span>
                <cargo-advance-select
                  :disabled="!priorityMediumEnable"
                  :default-value="trackingForm.trackingWtPriority.conditionFieldMedium"
                  :static-options="priorityConditions"
                  tag-value="code"
                  filterable
                  filter-type="global"
                  :cache="false"
                  style="margin-left: 10px; width: 296px; display: inline-block"
                  @parentCallBack="p=>{trackingForm.trackingWtPriority.conditionFieldMedium=p.value}"
                />
                <div style="margin-top: 10px;">
                  <el-select v-model="trackingForm.trackingWtPriority.triggerMethodMedium" :disabled="!priorityMediumEnable" style="width: 65px; margin-right: 5px">
                    <el-option :value="1" :label="$t('CargoMsg.Cargo_BringForward')" />
                    <el-option :value="2" :label="$t('CargoMsg.Cargo_Postpone')" />
                  </el-select>
                  <el-input-number v-model="trackingForm.trackingWtPriority.hourMedium" :disabled="!priorityMediumEnable" type="number" oninput="value=value.replace(/[^\d]/g,'')" :step="1" :controls="false" style="width: 112px; margin-left: 5px; margin-right: 5px" />
                  <span>{{ $t('Pricing.Hour') }}</span>
                  <el-input-number v-model="trackingForm.trackingWtPriority.minuteMedium" :disabled="!priorityMediumEnable" type="number" :min="0" :max="59" :step="1" :controls="false" style="width: 112px; margin-left: 5px; margin-right: 5px" />
                  <span>{{ $t('SeaExport.Minute') }}</span>
                </div>
              </el-form-item>
              <!--节点-工作任务信息-优先级-低-->
              <el-form-item>
                <el-checkbox v-model="priorityLowEnable" @change="priorityLowEnableChange()">{{ $t('CargoMsg.Cargo_HandlingPriorityMarkersLow') }}</el-checkbox>
              </el-form-item>
              <el-form-item>
                <span>{{ $t('CargoMsg.Cargo_ConditionalItem') + ': ' }}</span>
                <cargo-advance-select
                  :disabled="!priorityLowEnable"
                  :default-value="trackingForm.trackingWtPriority.conditionFieldLow"
                  :static-options="priorityConditions"
                  tag-value="code"
                  filterable
                  filter-type="global"
                  :cache="false"
                  style="margin-left: 10px; width: 296px; display: inline-block"
                  @parentCallBack="p=>{trackingForm.trackingWtPriority.conditionFieldLow=p.value}"
                />
                <div style="margin-top: 10px;">
                  <el-select v-model="trackingForm.trackingWtPriority.triggerMethodLow" :disabled="!priorityLowEnable" style="width: 65px; margin-right: 5px">
                    <el-option :value="1" :label="$t('CargoMsg.Cargo_BringForward')" />
                    <el-option :value="2" :label="$t('CargoMsg.Cargo_Postpone')" />
                  </el-select>
                  <!--              <el-input v-model="trackingForm.trackingWtPriority.hourLow" type="number" oninput="value=value.replace(/[^\d]/g,'')" style="width: 50px; margin-right: 5px" />-->
                  <el-input-number v-model="trackingForm.trackingWtPriority.hourLow" :disabled="!priorityLowEnable" type="number" oninput="value=value.replace(/[^\d]/g,'')" :step="1" :controls="false" style="width: 112px; margin-left: 5px; margin-right: 5px" />
                  <span>{{ $t('Pricing.Hour') }}</span>
                  <el-input-number v-model="trackingForm.trackingWtPriority.minuteLow" :disabled="!priorityLowEnable" type="number" :min="0" :max="59" :step="1" :controls="false" style="width: 112px; margin-left: 5px; margin-right: 5px" />
                  <span>{{ $t('SeaExport.Minute') }}</span>
                </div>
              </el-form-item>
            </div>
          </el-form>
        </el-card>
        <!--节点-工作任务信息-操作指令/特定业务规则-->
        <el-card v-if="trackingTemplateForm.workTaskEnable || isPlatform" class="box-card" style="width: 468px;">
          <el-form :disabled="readOnly" style="width:100%;" label-position="left" label-width="90px">
            <!--节点-工作任务信息-特定业务规则-->
            <span class="title" :title="$t('SystemMaintenance.ServiceScenarioApplication')">
              {{ $t('SystemMaintenance.ServiceScenarioApplication') }}
            </span>
            <el-form-item style="margin-left: 15px" :label="$t('SystemMaintenance.SettingApplicationScenarios')">
              <!--  选择 特定业务规则弹窗  -->
              <specific-business-rule-dialog
                width="600px"
                :lob="trackingForm.lob"
                :apply-sop-board="true"
                :specific-business-rule-uuid="trackingForm.trackingWtSpecificBusinessRule.specificBusinessRuleUuid"
                :specific-business-rules="specificBusinessRules"
                @change="p => specificBusinessRuleChange(p, trackingForm.trackingWtSpecificBusinessRule)"
              />
            </el-form-item>
            <el-form-item style="margin-left: 15px" :label="$t('CargoMsg.Cargo_SetParameterValues')">
              <!--  设置参数  -->
              <el-input v-model="trackingForm.trackingWtSpecificBusinessRule.ruleParam" no="ruleParam" type="textarea" :rows="3" style="width: 250px" />
            </el-form-item>

            <!--节点-工作任务信息-操作指令-->
            <span class="title" :title="$t('CargoMsg.Cargo_OperationButtonSettingsAndTip')" style="width: 100%">
              {{ $t('CargoMsg.Cargo_OperationButtonSettingsAndTip') }}
              <i style="color: #42b983; cursor: pointer; position: absolute; right: 35px; top: -4px; font-size: 18px" class="el-icon-circle-plus" @click="addTenantInstruction" />
            </span>
            <div v-for="(trackingWtInstruction, index) in trackingForm.trackingWtInstructions" :key="index" style="margin-left: 15px">
              <el-form-item :label="$t('CargoMsg.Cargo_SelectInstruction')">
                <!--  选择 租户操作指令弹窗  -->
                <tenant-instruction-dialog
                  width="600px"
                  :lob="trackingForm.lob"
                  :apply-sop-board="true"
                  :value="trackingWtInstruction.tenantInstructionUuid"
                  :tenant-instructions="tenantInstructions"
                  @change="p => tenantInstructionChange(p, trackingWtInstruction)"
                />
                <i style="color: #f56c6c; cursor: pointer; position: absolute; right: 35px; top: 5px; font-size: 18px" class="el-icon-remove" @click="deleteTrackingWtInstruction(index)" />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_SetParameters')">
                <!--  设置参数  -->
                <el-input v-model="trackingWtInstruction.instructionParam" no="instructionParam" type="textarea" :rows="3" style="width: 250px" />
              </el-form-item>
            </div>
          </el-form>
        </el-card>
      </div>
    </div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="templateSelectDialog.visible"
      :title="$t('SystemMaintenance.SelectSOPTemplateForNode')"
      width="400px"
      :close-on-click-modal="false"
      class="template-select-dialog"
    >
      <cargo-ag-grid
        :grid-options="templateSelectDialog.gridOptions"
        :row-data="templateSelectDialog.rowData"
        :show-side-bar="false"
        style="height: 360px;"
      />
      <div slot="footer" style="width: 100%;padding: 0 30px;">
        <el-checkbox v-model="templateSelectDialog.all" style="float: left;" @change="onSelectAllChange">{{ $t('Message.SelectAll') }}</el-checkbox>
        <el-button no="ok" type="primary" @click="doTemplateSelect">{{ $t('common.btn.ok') }}</el-button>
        <el-button no="cancel" @click="templateSelectDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import { Assert } from '@/utils/validate'
import { cache, cacheName } from '@/utils/cacheManager'
import deleteIcon from '@/assets/delete1.svg'
import addIcon from '@/assets/add1.svg'
import CargoElUpload from '@/components/Cargo/Common/cargoElUpload'
import URL from '@/api/urlTranslator'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { clearTrackingDocumentId } from '@/api/sysManage/baseConfig/businessManage'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import SpecificBusinessRuleDialog
  from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/specificBusinessRuleDialog'
import TenantInstructionDialog from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/tenantInstructionDialog'
import { getLobPositionList } from '@/api/sysManage/uiCustom'

export default {
  name: 'TrackingForm',
  components: { CargoElUpload, cargoAdvanceSelect, SpecificBusinessRuleDialog, TenantInstructionDialog },
  props: {
    treeNode: { type: Object, default: null },
    trackingTree: { type: Object, default: null },
    trackingForm: {
      type: Object,
      default: () => {}
    },
    platformData: { // 平台模板数据
      type: Object,
      default: () => {}
    },
    opStatus: { type: String, default: '' }, // 操作状态：add|edit|read
    templateTreeData: { type: Array, default: () => [] },
    preTrackingOptions: { type: Array, default: () => [] }, // sop 前置节点 tracking 下拉框
    trackingDetails: { type: Array, default: () => [] }, // sop 前置节点 trackingDetails 下拉框（所有下拉框的数据来源）
    priorityConditions: { type: Array, default: () => [] }, // sop 优先级 条件项 下拉框
    trackingTemplateForm: {
      type: Object,
      default: () => {}
    },
    specificBusinessRules: { type: Array, default: () => [] }, // 特定业务规则
    tenantInstructions: { type: Array, default: () => [] } // 租户操作指令
  },
  data() {
    return {
      URL,
      platformCodeMap: {},
      platformCNameMap: {},
      platformENameMap: {},
      currentIcon: '',
      currentCss: '',
      storageURL: '',
      isPlatformCode: false,
      templateSelectDialog: {
        visible: false,
        gridOptions: {
          groupDefaultExpanded: 1,
          suppressRowClickSelection: true,
          treeData: true,
          getDataPath: data => {
            return data.path.split(',')
          },
          autoGroupColumnDef: {
            width: 318,
            suppressMenu: true,
            tooltipField: 'chineseName',
            cellRendererParams: {
              suppressDoubleClickExpand: true,
              innerRenderer: params => {
                if (params.data.type === 2) {
                  const iconName = params.data.checked
                    ? 'checkbox-checked'
                    : 'checkbox-notChecked'
                  return `<svg class="svg-icon" aria-hidden="true" style="height:1.2em;width:1.2em;vertical-align:text-bottom;">
                            <use xlink:href="#icon-${iconName}"></use>
                          </svg>
                          &nbsp;${params.data.chineseName}`
                }
                return params.data.chineseName
              }
            },
            onCellClicked: params => {
              if (params.data.type === 2) {
                if (params.data.uuid === this.trackingForm.trackingTemplateUuid) {
                  return
                }
                const checked = !params.data.checked
                params.data.checked = checked
                params.api.refreshCells({ force: true })
                this.validateSelectAll()
              }
            }
          },
          columnDefs: [],
          context: {
            componentParent: this
          }
        },
        rowData: [],
        all: false
      },
      applicationTemplateLabel: '',
      selectTypeNames: TYPE_NAMES,
      SystemConstants: SystemConstants,
      positionEnable: false,
      personnelEnable: false,
      preTrackingDetailOptions: [],
      // priorityConditionMap: new Map(), // map<lob , list<条件>>
      // priorityConditions: [],
      priorityHighEnable: false,
      priorityMediumEnable: false,
      priorityLowEnable: false,
      positionOptions: [
        SystemConstants.POSITIONS_SALES, SystemConstants.POSITIONS_OP, SystemConstants.POSITIONS_CSR,
        SystemConstants.POSITIONS_OVERSEAOP, SystemConstants.POSITIONS_DC, SystemConstants.POSITIONS_PLANNER,
        SystemConstants.POSITIONS_CARGOSALES, SystemConstants.POSITIONS_SITEOP, SystemConstants.POSITIONS_USERDEFINEDROLEID1,
        SystemConstants.POSITIONS_USERDEFINEDROLEID2, SystemConstants.POSITIONS_USERDEFINEDROLEID3, SystemConstants.POSITIONS_USERDEFINEDROLEID4,
        SystemConstants.POSITIONS_USERDEFINEDROLEID5, SystemConstants.POSITIONS_USERDEFINEDROLEID6, SystemConstants.POSITIONS_USERDEFINEDROLEID7
      ],
      designatedPositions: [], // 指定岗位多选
      designatedPersons: [] // 指定人员多选
    }
  },
  computed: {
    isNew() {
      return this.opStatus === 'add'
    },
    isEdit() {
      return this.opStatus === 'edit'
    },
    readOnly() {
      return this.opStatus === 'read'
    },
    title() {
      if (this.readOnly) {
        return this.$t('CargoMsg.Cargo_LookNode')
      }
      return this.isNew ? this.$t('CargoMsg.Cargo_NewNode') : this.$t('CargoMsg.Cargo_EditNode')
    },
    isPlatform() {
      return this.$store.getters.tenantId === 1
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    isSE() {
      return this.trackingForm.lob === 'SE'
    },
    lob() {
      return this.trackingForm.lob
    }
    // ,
    // positionEnable() {
    //   return !!this.trackingForm.trackingWtPosition.position && this.trackingForm.trackingWtPosition.position !== SystemConstants.POSITIONS_PERSONNEL.code
    // },
    // personnelEnable() {
    //   return !!this.trackingForm.trackingWtPosition.position && this.trackingForm.trackingWtPosition.position === SystemConstants.POSITIONS_PERSONNEL.code
    // }
  },
  watch: {
    trackingForm() {
      this.applicationTemplateLabel = ''
    },
    lob: {
      immediate: true,
      handler(newVal) {
        getLobPositionList({ lob: newVal }).then(res => {
          const positionNameMap = new Map()
          for (const item of res.data) {
            switch (item.positionField) {
              case 'dc':
                positionNameMap.set(SystemConstants.POSITIONS_DC.code, item.label)
                break
              case 'cargoSalesId':
                positionNameMap.set(SystemConstants.POSITIONS_CARGOSALES.code, item.label)
                break
              case 'siteOP':
                positionNameMap.set(SystemConstants.POSITIONS_SITEOP.code, item.label)
                break
              case 'userDefinedRoleId1':
                positionNameMap.set(SystemConstants.POSITIONS_USERDEFINEDROLEID1.code, item.label)
                break
              case 'userDefinedRoleId2':
                positionNameMap.set(SystemConstants.POSITIONS_USERDEFINEDROLEID2.code, item.label)
                break
              case 'userDefinedRoleId3':
                positionNameMap.set(SystemConstants.POSITIONS_USERDEFINEDROLEID3.code, item.label)
                break
              case 'userDefinedRoleId4':
                positionNameMap.set(SystemConstants.POSITIONS_USERDEFINEDROLEID4.code, item.label)
                break
              case 'userDefinedRoleId5':
                positionNameMap.set(SystemConstants.POSITIONS_USERDEFINEDROLEID5.code, item.label)
                break
              case 'userDefinedRoleId6':
                positionNameMap.set(SystemConstants.POSITIONS_USERDEFINEDROLEID6.code, item.label)
                break
              case 'userDefinedRoleId7':
                positionNameMap.set(SystemConstants.POSITIONS_USERDEFINEDROLEID7.code, item.label)
                break
              default:
                positionNameMap.set(item.positionField, item.label)
                break
            }
          }
          for (let i = 0; i < this.positionOptions.length; i++) {
            const item = this.positionOptions[i]
            if (positionNameMap.has(item.code)) {
              this.positionOptions[i] = { ...item, chineseName: positionNameMap.get(item.code) }
            }
          }
        })
      }
    }
  },
  mounted() {
  },
  methods: {
    onShow() {
      // 将被删除的节点过滤掉
      const trackingWtPreNodes = []
      if (this.trackingForm.trackingWtPreNodes && this.trackingForm.trackingWtPreNodes.length > 0) {
        this.trackingForm.trackingWtPreNodes.forEach(preNode => {
          if (this.preTrackingOptions && this.preTrackingOptions.length > 0) {
            const preTrackings = this.preTrackingOptions.filter(item => item.uuid === preNode.preTrackingUuid)
            if (preTrackings && preTrackings.length > 0) {
              if (preNode.trackingDetails && preNode.trackingDetails.length > 0) {
                const preTrackingDetails = preNode.trackingDetails.filter(item => item.uuid === preNode.preTrackingDetailUuid)
                if (preTrackingDetails && preTrackingDetails.length > 0) {
                  trackingWtPreNodes.push(preNode)
                }
              }
            }
          }
        })
      }
      this.trackingForm.trackingWtPreNodes = trackingWtPreNodes

      this.positionEnable = false
      this.personnelEnable = false
      this.designatedPositions = []
      this.designatedPersons = []
      for (const item of this.trackingForm.trackingWtPositions) {
        if (item.position === SystemConstants.POSITIONS_PERSONNEL.code) {
          this.personnelEnable = true
          this.designatedPersons.push(item.userId)
        } else {
          this.positionEnable = true
          this.designatedPositions.push(item.position)
        }
      }
      if (this.isPlatform) {
        return
      }
      this.mouseleaveIcon()
      const platformData = this.platformData[this.trackingForm.lob]
      const trackingList = platformData.trackingList
      if (trackingList && trackingList.length > 0) {
        const codeMap = {}
        const cNameMap = {}
        const eNameMap = {}
        for (const data of trackingList) {
          codeMap[data.code] = data
          cNameMap[data.codeCname] = data
          eNameMap[data.codeEname] = data
        }
        this.platformCodeMap = codeMap
        this.platformCNameMap = cNameMap
        this.platformENameMap = eNameMap
        this.isPlatformCode = codeMap.hasOwnProperty(this.trackingForm.code)
      }
      // this.priorityConditions = this.priorityConditionMap[this.trackingForm.lob]
      if (this.trackingForm.trackingWtPriority) {
        this.priorityHighEnable = !!this.trackingForm.trackingWtPriority.conditionFieldHigh
        this.priorityMediumEnable = !!this.trackingForm.trackingWtPriority.conditionFieldMedium
        this.priorityLowEnable = !!this.trackingForm.trackingWtPriority.conditionFieldLow
      }
      if (this.trackingForm && this.trackingForm.genDocCondition === 0) {
        this.trackingForm.genDocCondition = ''
      }
      if (this.trackingForm && this.trackingForm.buttonName === 0) {
        this.trackingForm.buttonName = ''
      }
    },
    async checkForm() {
      const { code, nodeType, codeCname, codeEname } = { ...this.tracking }
      const psInput = this.$t('CargoMsg.Cargo_PlsInput')
      await Assert.isNotBlank(code, psInput + this.$t('CargoMsg.Cargo_Code'))
      await Assert.isNotBlank(nodeType, psInput + this.$t('CargoMsg.Cargo_NodeType'))
      await Assert.isNotBlank(codeCname, psInput + this.$t('CargoMsg.Cargo_ChineseNamed'))
      await Assert.isNotBlank(codeEname, psInput + this.$t('CargoMsg.Cargo_EnglishNamed'))
    },
    checkPlatform(fileName, value) {

    },
    // 悬浮
    mouseoverIcon() {
      if (!this.trackingForm.uuid) return
      if (!this.trackingForm.documentId) return
      this.currentIcon = deleteIcon
      this.currentCss = 'opacity: 0.5; background: #000000;'
    },
    // 点击
    clickIcon() {
      if (!this.trackingForm.uuid) return
      if (this.currentIcon === deleteIcon) { // 删除
        // 保存节点
        const loading = getLoading4Cxt()
        clearTrackingDocumentId({ anyStr: this.trackingForm.uuid }).then(res => {
          const result = res.data
          if (result > 0) {
            this.trackingForm.documentId = ''
            this.$message.success(this.$t('CargoMsg.Cargo_DeletedSuccessfully'))
            this.$emit('refresh', this.trackingForm)
          }
          this.mouseleaveIcon()
        }).finally(() => {
          loading.close()
        })
      }
    },
    // 移开
    async mouseleaveIcon() {
      if (!this.trackingForm.uuid) return
      if (this.trackingForm.documentId) {
        if (!this.storageURL) {
          await cache.load(cacheName.CONFIG)
          this.storageURL = cache.config.get('StorageURL')
        }
        this.currentIcon = `${URL.common.findByFileId}/${this.trackingForm.documentId}?sessionId=${this.$store.getters.token}`
        this.currentCss = 'background: #dddfe6;'
      } else {
        this.currentIcon = addIcon
        this.currentCss = 'background: #ffffff;'
      }
    },
    beforeUpload(file) {
      if (file.size > (500 * 1024)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_UploadDataSizeMore500KB'))
        return false
      }
      return true
    },
    // 图片上传
    handleProgress() {
      this.loading = getLoading4Cxt()
    },
    // 上传成功
    handleSuccess(response, file, fileList) {
      if (this.loading) this.loading.close()
      const documentId = response.data
      if (documentId) {
        this.trackingForm.documentId = documentId
        this.$message.success(this.$t('Pricing.UploadSucceed'))
        this.mouseleaveIcon()
        this.$emit('refresh', this.trackingForm)
      } else {
        this.$message.error(this.$t('Pricing.UploadFailed'))
      }
    },
    // 上传失败
    handleError(error) {
      const errorData = JSON.parse(error.message)
      this.$message.error({ 'message': errorData.message, 'duration': 15000 })
      if (this.loading) this.loading.close()
    },
    onApplicationScopeChange() {
      if (this.isNew && this.trackingForm.applicationScope === 1) {
        const keys = []
        const names = []
        for (const item of this.templateTreeData) {
          const arr = item.path.split(',')
          if (arr.length > 0 && arr[0] === this.trackingForm.lob && item.type === 2) {
            keys.push(item.uuid)
            names.push(item.chineseName)
          }
        }
        this.trackingForm.applicationTemplate = keys.join(',')
        this.applicationTemplateLabel = names.join(',')
      }
    },
    showTemplateSelectDialog() {
      const keys = this.trackingForm.applicationTemplate ? this.trackingForm.applicationTemplate.split(',') : []
      const rowData = []
      for (const item of this.templateTreeData) {
        const arr = item.path.split(',')
        if (arr.length > 0 && arr[0] === this.trackingForm.lob) {
          let checked = false
          if (item.type === 2) {
            if (item.uuid === this.trackingForm.trackingTemplateUuid) {
              checked = true
            } else if (keys.includes(item.uuid)) {
              checked = true
            }
          }
          rowData.push({ ...item, checked })
        }
      }
      this.templateSelectDialog.rowData = rowData
      this.validateSelectAll()
      this.templateSelectDialog.visible = true
    },
    validateSelectAll() {
      this.templateSelectDialog.all = true
      for (const row of this.templateSelectDialog.rowData) {
        if (row.type === 2 && !row.checked) {
          this.templateSelectDialog.all = false
          break
        }
      }
    },
    onSelectAllChange() {
      if (this.templateSelectDialog.all) {
        for (const row of this.templateSelectDialog.rowData) {
          if (row.type === 2) {
            row.checked = true
          }
        }
      } else {
        for (const row of this.templateSelectDialog.rowData) {
          if (row.type === 2 && row.uuid !== this.trackingForm.trackingTemplateUuid) {
            row.checked = false
          }
        }
      }
      this.templateSelectDialog.gridOptions.api.refreshCells({ force: true })
    },
    doTemplateSelect() {
      this.$confirm(this.$t('SystemMaintenance.ConfirmJoinSelectTemplate'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        const keys = []
        const names = []
        for (const row of this.templateSelectDialog.rowData) {
          if (row.type === 2 && row.checked) {
            keys.push(row.uuid)
            names.push(row.chineseName)
          }
        }
        this.trackingForm.applicationTemplate = keys.join(',')
        this.applicationTemplateLabel = names.join(',')
        this.templateSelectDialog.visible = false
      }).catch(() => {})
    },
    positionEnableChange() {
      if (this.positionEnable) {
        this.personnelEnable = false
        this.designatedPersons = []
      } else {
        this.designatedPositions = []
      }
    },
    personnelEnableChange() {
      if (this.personnelEnable) {
        this.positionEnable = false
        this.designatedPositions = []
      } else {
        this.designatedPersons = []
      }
    },
    preTrackingChange(event, trackingWtPreNode) {
      trackingWtPreNode.preTrackingDetailUuids = null
      trackingWtPreNode.trackingDetails = this.trackingDetails.filter(item => item.parentUuid === trackingWtPreNode.preTrackingUuid)
    },
    addTrackingWtPreNode() {
      if (this.readOnly) {
        return
      }
      if (this.trackingForm.trackingWtPreNodes && this.trackingForm.trackingWtPreNodes.length === 5) {
        return
      }
      this.trackingForm.trackingWtPreNodes.push({
        preTrackingUuid: null,
        preTrackingDetailUuids: null
      })
    },
    deleteTrackingWtPreNode(index) {
      if (this.readOnly) {
        return
      }
      this.trackingForm.trackingWtPreNodes.splice(index, 1)
    },
    priorityHighEnableChange() {
      if (!this.trackingForm.priorityHighEnable) {
        this.trackingForm.trackingWtPriority.conditionFieldHigh = null
        this.trackingForm.trackingWtPriority.triggerMethodHigh = null
        this.trackingForm.trackingWtPriority.hourHigh = null
        this.trackingForm.trackingWtPriority.minuteHigh = null
      }
    },
    priorityMediumEnableChange() {
      if (!this.trackingForm.priorityMediumEnable) {
        this.trackingForm.trackingWtPriority.conditionFieldMedium = null
        this.trackingForm.trackingWtPriority.triggerMethodMedium = null
        this.trackingForm.trackingWtPriority.hourMedium = null
        this.trackingForm.trackingWtPriority.minuteMedium = null
      }
    },
    priorityLowEnableChange() {
      if (!this.trackingForm.priorityLowEnable) {
        this.trackingForm.trackingWtPriority.conditionFieldLow = null
        this.trackingForm.trackingWtPriority.triggerMethodLow = null
        this.trackingForm.trackingWtPriority.hourLow = null
        this.trackingForm.trackingWtPriority.minuteLow = null
      }
    },
    async saveCheck() {
      const psInput = this.$t('CargoMsg.Cargo_PlsInput')
      const { trackingWtPreNodes, trackingWtPriority, trackingWtInstructions } = { ...this.trackingForm }
      const trackingWtPositions = []
      if (this.positionEnable) {
        if (!this.designatedPositions || this.designatedPositions.length === 0) {
          await Assert.isTrue(false, psInput + this.$t('CargoMsg.AssignedWorkResponsibleForNode'))
        }
        for (const position of this.designatedPositions) {
          trackingWtPositions.push({ position })
        }
      }
      if (this.personnelEnable) {
        if (!this.designatedPersons || this.designatedPersons.length === 0) {
          await Assert.isTrue(false, psInput + this.$t('CargoMsg.Cargo_DesignatedPersonnel'))
        }
        for (const person of this.designatedPersons) {
          trackingWtPositions.push({ position: SystemConstants.POSITIONS_PERSONNEL.code, userId: person })
        }
      }
      this.trackingForm.trackingWtPositions = trackingWtPositions
      if (trackingWtPreNodes && trackingWtPreNodes.length > 0) {
        const preNodeKeySet = new Set()
        for (const trackingWtPreNode of trackingWtPreNodes) {
          if (!trackingWtPreNode.preTrackingUuid || !trackingWtPreNode.preTrackingDetailUuids) {
            await Assert.isTrue(false, psInput + this.$t('CargoMsg.Cargo_PreNode'))
          }
          const key = trackingWtPreNode.preTrackingUuid
          if (preNodeKeySet.has(key)) {
            await Assert.isTrue(false, this.$t('CargoMsg.Cargo_PreNodeRepeat'))
          }
          preNodeKeySet.add(key)
        }
      }
      const priorityKeySet = new Set()
      if (this.priorityHighEnable) {
        if (!trackingWtPriority || !trackingWtPriority.conditionFieldHigh || !trackingWtPriority.triggerMethodHigh) {
          await Assert.isTrue(false, psInput + this.$t('CargoMsg.Cargo_PriorityHigh'))
        }
        const key = trackingWtPriority.conditionFieldHigh + '_' + trackingWtPriority.triggerMethodHigh + '_' +
          trackingWtPriority.hourHigh + '+' + trackingWtPriority.minuteHigh
        priorityKeySet.add(key)
      }
      if (this.priorityMediumEnable) {
        if (!trackingWtPriority || !trackingWtPriority.conditionFieldMedium || !trackingWtPriority.triggerMethodMedium) {
          await Assert.isTrue(false, psInput + this.$t('CargoMsg.Cargo_PriorityMedium'))
        }
        const key = trackingWtPriority.conditionFieldMedium + '_' + trackingWtPriority.triggerMethodMedium + '_' +
          trackingWtPriority.hourMedium + '+' + trackingWtPriority.minuteMedium
        if (priorityKeySet.has(key)) {
          await Assert.isTrue(false, this.$t('CargoMsg.Cargo_PriorityRepeat'))
        }
        priorityKeySet.add(key)
      }
      if (this.priorityLowEnable) {
        if (!trackingWtPriority || !trackingWtPriority.conditionFieldLow || !trackingWtPriority.triggerMethodLow) {
          await Assert.isTrue(false, psInput + this.$t('CargoMsg.Cargo_PriorityLow'))
        }
        const key = trackingWtPriority.conditionFieldLow + '_' + trackingWtPriority.triggerMethodLow + '_' +
          trackingWtPriority.hourLow + '+' + trackingWtPriority.minuteLow
        if (priorityKeySet.has(key)) {
          await Assert.isTrue(false, this.$t('CargoMsg.Cargo_PriorityRepeat'))
        }
      }
      if (trackingWtInstructions && trackingWtInstructions.length > 0) {
        let checkNullFlag = false
        const distinctInstructionUuidSet = new Set()
        trackingWtInstructions.forEach(p => {
          if (!p.tenantInstructionUuid) {
            checkNullFlag = true
          }
          distinctInstructionUuidSet.add(p.tenantInstructionUuid)
        })
        await Assert.isTrue(!checkNullFlag, this.$t('CargoMsg.Cargo_OperationInstructionSetTip'))
        await Assert.isTrue(distinctInstructionUuidSet.size === trackingWtInstructions.length, this.$t('CargoMsg.Cargo_OperationInstructionRepeatTip'))
      }
    },
    addTenantInstruction() {
      if (this.readOnly) {
        return
      }
      if (this.trackingForm.trackingWtInstructions && this.trackingForm.trackingWtInstructions.length === 5) {
        return
      }
      this.trackingForm.trackingWtInstructions.push({
        tenantInstructionUuid: null,
        instructionParam: null
      })
    },
    // 选择 租户操作指令
    tenantInstructionChange(data, trackingWtInstruction) {
      if (data) {
        trackingWtInstruction.tenantInstructionUuid = data.uuid
      } else {
        trackingWtInstruction.tenantInstructionUuid = ''
      }
    },
    deleteTrackingWtInstruction(index) {
      if (this.readOnly) {
        return
      }
      this.trackingForm.trackingWtInstructions.splice(index, 1)
    },
    // 选择 特定业务规则
    specificBusinessRuleChange(data, trackingWtSpecificBusinessRule) {
      if (data) {
        trackingWtSpecificBusinessRule.specificBusinessRuleUuid = data.uuid
      } else {
        trackingWtSpecificBusinessRule.specificBusinessRuleUuid = ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .tracking-form /deep/ {
    .box-card {
      .el-card__header{
        padding: 10px 20px !important;
      }
      .el-radio__label {
        font-size: 12px;
      }
    }
    .template-select-dialog {
      .cargo-ag-grid {
        .ag-header {
          display: none;
        }
      }
    }
    .title{
      display: inline-block;
      position: relative;
      font-size: 13px;
      padding-left: 15px;
      line-height: 14px;
      margin-bottom: 10px;
    }
    .title:before {
      content: '';
      position: absolute;
      width: 4px;
      top: 0;
      left: 0;
      bottom: 0;
      background-color: #1F75D5;
    }
  }
</style>
